import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RetailerHomeService } from '../../retailer-home/retailer-home.service';

@Component({
  selector: 'app-print-recipt2',
  templateUrl: './print-recipt2.component.html',
  styleUrls: ['./print-recipt2.component.scss']
})
export class PrintRecipt2Component {
  ID: any
  printData: any
  todayDate = new Date()
  loader = true
  TotalOrderAmount = 0
  constructor(
    public activatedRoute: ActivatedRoute,
    public service: RetailerHomeService,
    private toastr: ToastrService
  ) {
    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    this.Reset()
    this.LoadPrintData()
  }
  Reset() {
    this.printData = {
      totalAMount: 0,
      senderName: "",
      orderPhone: "",
      orderNumber: "",
      recieverName: "",
      recieverPhone: "",
      orderStatue: "",
      hasDeliverableItems: false,
      orderItems: []
    }
  }
  LoadPrintData() {
    this.loader = true
    this.service.PrintRecipt(this.ID).subscribe
      ({
        next: (res: any) => {
          console.log(res)
          if(res.Message=='Object reference not set to an instance of an object.'){
            this.toastr.error(res.Message,'Oops! 500');
            this.loader=false
          }
          this.printData = res
          for (let i = 0; i < res.orderItems.length; i++) {
            this.TotalOrderAmount = this.TotalOrderAmount + res.orderItems[i].totalRetailPrice
          }
          this.loader = false
          setInterval(() => {
            // window.print()
          }, 5000);
          // window.print()
        },
        error:e=>{
          this.loader=false
          if(e.error.message){
            this.toastr.error(e.message,'Oops!');
          }
          else{
            this.toastr.error("Something went wrong",'Oops!');
          }
        }
      })
  }

  print() {
    window.print();
}
}
